export class FR {
    getTranslations() {
        return {
            btn_validate: 'Confirmer',
            btn_cancel: 'Annuler',
            btn_close: 'Fermer',
            btn_add: 'Ajouter',
            btn_delete: 'Supprimer',
            msg_alert: 'Alerte',
            msg_success: 'Succès',
            msg_confirm: 'Veuillez confirmer',
            msg_input: 'Saisie',
            datahub_pickup_indicator: 'Choisir des indicateurs',
            datahub_fields: 'Champs',
            config_menu_loading: 'Chargement du menu...',
            editable_label_edit: 'Cliquez pour éditer',
            editable_label_validate: "Valider l'édition",
            please_wait: 'Veuillez patienter...',
            combobox_placeholder: 'Sélectionner une option',
            card_button_start: 'Démarrer',
            enter_credentials_to: 'Veuillez entrer vos identifiants pour accéder à ',
        };
    }
}
